import transactionApi from '../../../../api/transaction';
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';

const defaultState = () => ({
	prov_register: {},
	city_register: {},
})

const state = defaultState();
const getters = {};

const mutations = {
	defineProv(state, data){
		state.prov_register = data
	},
	defineCity(state, data){
		state.city_register = data
	}
}

const actions = {
	async registerArea({ commit, dispatch }, param) {
		commit(PROGRESS_START, null, { root: true });

		await transactionApi.registerArea(param).then(({ data: { data } }) => {
			if (param.type == "province") {
				commit('defineProv', data.results);
			} else if (param.type == "city") {
				commit('defineCity', data.results);
			}
			
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
}
export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};